<template>
  <MarketPage v-if="componentName === 'market'" />
  <MarketSourcePage v-if="componentName === 'marketsource'" />
  <InstrumentPage v-if="componentName === 'instrument'" />
  <DatasetPage v-if="componentName === 'dataset'" />
  <InstrumentSourcePage v-if="componentName === 'instrumentsource'" />
  <TransformationPage v-if="componentName === 'transformation'" />
  <TestTermPage v-if="componentName === 'termparsetest' || componentName === 'parsebyterm'" />
</template>

<script>
import {
  MarketPage,
  MarketSourcePage,
  InstrumentPage,
  DatasetPage,
  InstrumentSourcePage,
  TransformationPage,
  TestTermPage,
} from "./exporter.js";
export default {
  name: "data-pipeline-transformation",
  data() {
    return {
      componentName: "",
    };
  },
  components: {
    MarketPage,
    MarketSourcePage,
    InstrumentPage,
    DatasetPage,
    InstrumentSourcePage,
    TransformationPage,
    TestTermPage,
  },
  mounted() {
    const routePathMatch = this.$route.params.pathMatch[0].toLowerCase();

    if (this.$route.params.pathMatch.length === 2 || routePathMatch === 'termparsetest' || routePathMatch === 'parsebyterm')
      this.componentName = routePathMatch;
    else if (this.$route.params.pathMatch.length === 1)
      this.componentName = "transformation";
  },
};
</script>
